export { default } from './FeeTable';
